module.exports = __webpack_public_path__ + "static/media/hero-big-subscribed.ac1c74cf.jpg";